import { openBlock as o, createElementBlock as t, createElementVNode as n } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "ads-icon-close",
  viewBox: "0 0 24 24"
};
function r(s, e) {
  return o(), t("svg", l, e[0] || (e[0] = [
    n("path", { d: "M19.53 5.53a.75.75 0 0 0-1.06-1.06L12 10.94 5.53 4.47a.75.75 0 0 0-1.06 1.06L10.94 12l-6.47 6.47a.75.75 0 1 0 1.06 1.06L12 13.06l6.47 6.47a.75.75 0 1 0 1.06-1.06L13.06 12z" }, null, -1)
  ]));
}
const a = { render: r };
export {
  a as I
};
